<template>
    <div class="flex gap-4 py-4 pl-3 pr-4 bg-white rounded-2xl">
        <img class="w-[48px] h-[48px]" :src="avaratUrl" alt="">
        <div class="flex flex-col gap-[10px]">
            <p class="text-small-size-1 text-main-1">{{ name }}</p>
            <p v-if="title" class="font-medium text-gray_1">{{ title }}</p>
            <p v-if="description" class="" :class="descriptionStype" v-html="description"></p>
        </div>
    </div>
</template>
<script>
export default {
    props: ['avaratUrl', 'name', 'title', 'description', 'descriptionStype'],
    data() {
        return {
        }
    }
}
</script>